import { generateClient } from 'aws-amplify/api'
import { reportPlatformIssue as reportPlatformIssueMutation } from '@/graphql/mutations'
import { parseAwsJson } from '@/utils/graphql'
import { getApiMessage } from '@/mixins/Extras/ApiResponse'

const client = generateClient()

/**
 * "Raise an Issue" -- files a real Jira ticket (project KAN) from inside the
 * Portal, with an optional screenshot of exactly what the reporter was
 * looking at. Reporter/org context is filled in server-side from the
 * session, not sent from here.
 */
export async function reportPlatformIssue({
  summary,
  description = '',
  issueType = 'bug',
  screenshotBase64 = '',
  pageTitle = '',
  pageUrl = '',
}) {
  const input = {
    summary: String(summary ?? '').trim(),
    description: String(description ?? '').trim() || undefined,
    issue_type: String(issueType ?? 'bug').trim() || undefined,
    screenshot_base64: screenshotBase64 || undefined,
    page_title: String(pageTitle ?? '').trim() || undefined,
    page_url: String(pageUrl ?? '').trim() || undefined,
  }

  try {
    const { data, errors } = await client.graphql({
      query: reportPlatformIssueMutation,
      variables: { input },
    })

    if (errors?.length) {
      throw new Error(errors[0].message)
    }

    return parseAwsJson(data?.reportPlatformIssue)
  } catch (error) {
    return {
      status: 'ERROR',
      message: getApiMessage(error, 'Failed to report the issue.'),
    }
  }
}
